import { FakeBotMessage } from '@baishuyun/ai-design';

export const ErrorFallbackMsg = ({ error }: { error?: string }) => {
  return (
    <FakeBotMessage headless>
      {error || '出现了一些问题，无法显示预览内容，请稍后重试。'}
    </FakeBotMessage>
  );
};
